import { Helmet } from "react-helmet";
import customCSS from "./Allpayments.module.css";
import "./Updateusers.css";
import ReactGA from "react-ga4";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ENV from "../../constants/env-constants";
import { formatNumbers } from "../../utils/formatNumbers";
import { UserDetailsSetingsForm } from "../../dashboard/pages/Settings";
import { CloseButton, PlusIcon } from "../../components/SvgComponents";
import { SignupFormComponent } from "../../pages/Signup";
import { signupUser } from "../../utils/api";
import Swal from 'sweetalert2'

export default function UpdateUsers() {
    const location = useLocation();
    const [allUsersData, setAllUsersData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [isAddUserPageOpen, setIsAddUserPageOpen] = useState(false);
    const [customErrorMessage, setCustomErrorMessage] = useState('');
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    function handleCloseSelectedUser() {
      setSelectedRowData(null);
      setIsAddUserPageOpen(false);
      setIsButtonLoading(false);
    }
    function fetchAllUsersData() {
      fetch(`${ENV.API_URL}/api/allusers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setAllUsersData(data);
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
    }
    function openAddUserForm() {
      setIsAddUserPageOpen(true);
    }
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin Update-Users Page' });
        fetchAllUsersData()
      }, []);
    function saveButtonCallbackFunction() {
      setSelectedRowData(null);
      fetchAllUsersData();
    }
    async function handleAddUserSubmition(values) {
      try {
        setIsButtonLoading(true);
        setCustomErrorMessage("");
        values.password = values.email;
        const response = await signupUser(values, 'USER_ADDED_BY_ADMIN');
      if (response.ok) {
        Swal.fire({
          title: "User added successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true
        })
        setIsAddUserPageOpen(false);
        fetchAllUsersData();
      } else {
        const errorData = await response.json();
        setCustomErrorMessage(errorData.message || "An unexpected error occurred. Please try again.");
      }
      } catch (error) {
        console.error('Signup failed:', error);
        setCustomErrorMessage(error.message || "An error occurred. Please try again.");
      }
      setIsButtonLoading(false);
    }
    const userId = localStorage.getItem('userid');
    const rowsPerPage = 10;
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allUsersData.slice(indexOfFirstRow, indexOfLastRow);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(allUsersData.length / rowsPerPage); i++) {
      pageNumbers.push(i);
    }
    function OpenEditOrAddPage(selectedRowData, isAddUserPageOpen) {
      if (selectedRowData) return <UserValuesEditor userId={userId} initialValues={selectedRowData} handleCloseSelectedUser={handleCloseSelectedUser} saveButtonCallbackFunction={saveButtonCallbackFunction} />
      else if (isAddUserPageOpen) return <AddUserForm handleSubmit={handleAddUserSubmition} customErrorMessage={customErrorMessage} handleCloseSelectedUser={handleCloseSelectedUser} isButtonLoading={isButtonLoading} />
    }
    return <div style={{position: 'relative'}} className="layout-wrapper layout-content-navbar">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Update-Users</title>
        </Helmet>
        {
          selectedRowData || isAddUserPageOpen ? <div style={{
            height: '100%',
            width: '100%',
            padding: '5rem 10rem',
          }}>
            {OpenEditOrAddPage(selectedRowData, isAddUserPageOpen)}
          </div> : <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>Update Users</h1>

          <div className={customCSS.layoutWrapper}>
            <div className={customCSS.layoutContainer}>
              <div className={customCSS.tableWrapper}>
                <table className={customCSS.table}>
                  <thead>
                    <tr>
                      <th className={customCSS.th}>Id</th>
                      <th className={customCSS.th}>First Name</th>
                      <th className={customCSS.th}>Last Name</th>
                      <th className={customCSS.th}>Email</th>
                      <th className={customCSS.th}>Company/Organization</th>
                      <th className={customCSS.th}>Zipcode</th>
                      <th className={customCSS.th}>Country</th>
                      <th className={customCSS.th}>Usertype</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.map((user, index) => (
                      <tr className={customCSS.tr} onClick={()=> {setSelectedRowData(user)}} key={index}>
                        <td className={customCSS.td}>{user.id}</td>
                        <td className={customCSS.td}>{user.firstName || 'NA'}</td>
                        <td className={customCSS.td}>{user.lastName || 'NA'}</td>
                        <td className={customCSS.td}>{user.email || 'NA'}</td>
                        <td className={customCSS.td}>{user.companyOrOrganization || 'NA'}</td>
                        <td className={customCSS.td}>{user.zipcode || 'NA'}</td>
                        <td className={customCSS.td}>{user.country || 'NA'}</td>
                        <td className={customCSS.td}>{user.userType || 'NA'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={customCSS.pagination}>
                {pageNumbers.map(number => (
                  <button key={number} onClick={() => paginate(number)} className={customCSS.pageLink}>
                    {number}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div style={{display: 'flex', justifyContent: 'center', marginBottom: '2rem'}}>
            <span onClick={openAddUserForm} id="add-button">
              <span style={{height: '1.5rem', display: 'flex', width: '1.5rem'}}>
                <PlusIcon />
              </span>
              <span style={{fontSize: '1rem', paddingLeft: '0.5rem'}}>
                Add User
              </span>
            </span>
          </div>
        </div>
        }
    </div>
}

function UserValuesEditor({initialValues, handleCloseSelectedUser, saveButtonCallbackFunction}) {
  return <>
      <div style={{display: 'flex'}}>
        <span onClick={handleCloseSelectedUser} style={{height: '2rem', width: '2rem', color: 'green', marginLeft: 'auto', cursor: 'pointer'}}>
          <CloseButton />
        </span>
      </div>
      <UserDetailsSetingsForm userId={initialValues.id} initialValues={initialValues} callbackFunction={saveButtonCallbackFunction} />
    </>
}

function AddUserForm({handleSubmit, customErrorMessage, handleCloseSelectedUser, isButtonLoading}) {
  return <>
      <div style={{display: 'flex'}}>
        <span onClick={handleCloseSelectedUser} style={{height: '2rem', width: '2rem', color: 'green', marginLeft: 'auto', cursor: 'pointer'}}>
          <CloseButton />
        </span>
      </div>
      <SignupFormComponent
        handleSubmit={handleSubmit}
        customErrorMessage={customErrorMessage}
        buttonText="Add User"
        isButtonLoading={isButtonLoading}
        isRequiredInAdminDashboard={true}
      />
  </>
}